<template>
  <div>
    <div class="tree-wrapper" v-loading="loadTree">
      <div id="tree" class="tree-container">
        <!-- <canvas id="canvasForTree"></canvas> -->
      </div>
    </div>
    <div class="export-caontainer" v-show="notPrint">
      <div class="export-btn-wrap">
        <!-- <div>
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-download"
            round
            @click="outPutImage"
            >导出族谱</el-button
          >
        </div> -->
        <div>
          <el-dropdown trigger="click" @command="handleAddTypeAction">
            <el-button type="primary" size="small" icon="el-icon-download" round
              >导出族谱</el-button
            >
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in exportFileMenu"
                :key="item.command"
                :command="item.command"
                >{{ item.name }}
              </el-dropdown-item>
              <!-- <el-dropdown-item command="1">导出.png 图片</el-dropdown-item>
              <el-dropdown-item command="2">隐藏导出按钮</el-dropdown-item>
              <el-dropdown-item command="3">查看导出说明</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <span class="tip-text"
          >提示：导出前请适度缩小族谱，使之全部在视野里，并居中。</span
        >
        <exportExplain ref="exportExp" />
      </div>
    </div>
  </div>
</template>
<script>
import { apiMap } from "../utils/apiMap";
// import { birthToDate, formatDeadKey } from "../utils/feed";
import dTree from "../utils/dTree";
import { exportFileMenu } from "../utils/common";
import $ from "jquery";
import _ from "lodash";
import exportExplain from "../components/user/tree/export-tree-explain.vue";
import * as d3 from "d3";
// import html2canvas from "html2canvas";- 83
// import jsPDF from "jspdf";
export default {
  name: "clan-tree",
  data() {
    let cWidth = document.body.clientWidth;
    let sHeight = window.innerHeight || document.documentElement.clientHeight;
    console.log(sHeight);
    return {
      exportFileMenu,
      loadTree: true,
      boxWidth: 80,
      boxHeight: 30,
      fatherDivPad: 30,
      fatherDivWidth: 832,
      fatherDivHeight: 92,
      motherDivWidth: 832,
      motherDivHeight: 92,
      boxMargin: 11,
      mateScale: 15,
      husbandScale: 2,
      parentPosition: {},
      htmlTitle: "测试PDF",
      nowTime: "456456",
      exportName: "导出族谱.png",
      svgStyle: {
        width: cWidth,
        height: sHeight - 90,
      },
      notPrint: true,
    };
  },
  components: {
    exportExplain,
  },
  mounted() {
    this.getFamilyTree();
  },
  methods: {
    outPutImage() {
      this.dialogFormVisible = true;
      // this.notPrint = false;
      // document.querySelector("#tree").innerHTML = "";
      // this.getFamilyTree();
      //var node = document.querySelector("#pdfContainer");
      // console.log(node);
      // this.ExportSavePdf(this.htmlTitle, "#tree");
      // this.html2pdf();
      //this.exportPNG();
    },
    handleAddTypeAction(action) {
      switch (action) {
        case "1": {
          // var node = document.querySelector("#pdfContainer");
          // console.log(node);
          // this.ExportSavePdf(this.htmlTitle, "#tree");
          // this.html2pdf();
          this.exportPNG();
          break;
        }

        case "2": {
          this.notPrint = false;
          var cWidth = document.body.clientWidth;
          var sHeight =
            window.innerHeight || document.documentElement.clientHeight;
          this.svgStyle = {
            width: cWidth,
            height: sHeight,
          };
          document.querySelector("#tree").innerHTML = "";
          setTimeout(() => {
            this.getFamilyTree();
          }, 300);
          break;
        }

        case "3": {
          // this.docsDialogVisible = true;
          this.$refs["exportExp"].onSwitch();
          break;
        }
        default:
          break;
      }
    },
    html2pdf() {
      var element = $(document.querySelector("#tree")); // 这个dom元素是要导出pdf的div容器
      var w = element.width(); // 获得该容器的宽
      var h = element.height(); // 获得该容器的高
      var offsetTop = element.offset().top; // 获得该容器到文档顶部的距离
      var offsetLeft = element.offset().left; // 获得该容器到文档最左的距离
      var canvas = document.createElement("canvas");
      var abs = 0;
      var win_i = $(window).width(); // 获得当前可视窗口的宽度（不包含滚动条）
      var win_o = window.innerWidth; // 获得当前窗口的宽度（包含滚动条）
      if (win_o > win_i) {
        abs = (win_o - win_i) / 2; // 获得滚动条长度的一半
      }
      canvas.width = w * 2; // 将画布宽&&高放大两倍
      canvas.height = h * 2;
      var context = canvas.getContext("2d");
      context.scale(2, 2);
      context.translate(-offsetLeft - abs, -offsetTop);
      // 这里默认横向没有滚动条的情况，因为offset.left(),有无滚动条的时候存在差值，因此
      // translate的时候，要把这个差值去掉
      html2canvas(document.querySelector("#tree"), {
        scale: 2,
      }).then(function(canvas) {
        var contentWidth = canvas.width;
        var contentHeight = canvas.height;
        //一页pdf显示html页面生成的canvas高度;
        var pageHeight = (contentWidth / 592.28) * 841.89;
        //未生成pdf的html页面高度
        var leftHeight = contentHeight;
        //页面偏移
        var position = 0;
        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        var imgWidth = 595.28;
        var imgHeight = (592.28 / contentWidth) * contentHeight;

        var pageData = canvas.toDataURL("image/jpeg", 1.0);

        var pdf = new jsPDF("l", "pt", "a3");

        //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        //当内容未超过pdf一页显示的范围，无需分页
        //pdf.addImage(page.toDataURL("image/jpeg", 1.0), "JPEG", 10, 10, a4w, Math.min(a4h, a4w * page.height / page.width)) // 添加图像到页面，保留10mm边距
        if (leftHeight < pageHeight) {
          pdf.addImage(pageData, "JPEG", 10, 10, imgWidth, imgHeight);
        } else {
          // 分页
          while (leftHeight > 0) {
            pdf.addImage(pageData, "JPEG", 10, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            //避免添加空白页
            if (leftHeight > 0) {
              pdf.addPage();
            }
          }
        }

        pdf.save("测试" + new Date().getTime());
        var pdfData = pdf.output("datauristring"); //获取到base64 的pdf
        // console.log(pdfData);
      });
    },
    getFamilyTree() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      if (loginUser) {
        _this
          .$axios({
            baseURL: apiMap["commonUrl"],
            method: apiMap["fatherTree"]["method"],
            url: apiMap["fatherTree"]["url"],
            params: {
              token: loginUser.token,
              family: 1,
            },
          })
          .then(function(response) {
            if (response.data.result.statusCode == 1) {
              _this.treeData = response.data.result.data;
              // _this.ancestorNode = response.data.result.ancestors;
              _this.loadTree = false;
              _this.initTreeWithD3(_this.treeData);
              _this.setMeCenter();
            } else {
              _this.$message("您暂无族谱");
            }
          })
          .catch(function(error) {
            console.log(error);
            if (error.message.includes("Network")) {
              window.location.reload();
            }
          });
      } else {
        window.location = "/login";
      }
    },

    setMeCenter() {
      let meNode = document.querySelector(".is-me");
      if (!meNode.parentNode) {
        return;
      }
      let parNode = meNode.parentNode;
      let nodeX = parNode.getAttribute("x").slice(0, -2);
      let nodeY = parNode.getAttribute("y").slice(0, -2);
      const NumExp = /^(\-|\+)?\d+(\.\d+)?$/;
      if (!document.querySelector("#tree")) {
        return;
      }
      // let test = document.querySelector("#tree").children[0];
      // return;
      let svgNode = document.querySelector("#tree").children[0].children[0];
      // console.log(svgNode.getAttribute("transform").split(" "));
      let transformVal = svgNode.getAttribute("transform").split(" ");
      let translateAttr = transformVal[0];
      // let originScale = transformVal[1];
      let bracketS = translateAttr.indexOf("(") + 1;
      let bracketE = translateAttr.lastIndexOf(")");
      let aimStr = translateAttr.slice(bracketS, bracketE);
      let originTsf = aimStr.split(",");
      if (NumExp.test(nodeX) && NumExp.test(nodeY)) {
        // console.log(Number(nodeX), Number(nodeY));
        if (NumExp.test(originTsf[0]) && NumExp.test(originTsf[1])) {
          // console.log(Number(originTsf[0]));
          // let diffHeight = this.svgStyle.height-Number(nodeY);
          let trueHeight = document.querySelector("#tree").children[0]
            .clientHeight;
          let newWidth = Number(originTsf[0]) - Number(nodeX) - 40;
          let halfDiffH = trueHeight / 2 - Number(nodeY);
          let newHeight = Number(originTsf[1]) - 11 + halfDiffH;
          // console.log(Number(originTsf[1]) - 11 + halfDiffH);
          // console.log(newHeight);
          // let newVal = `translate(${newWidth},${newHeight}) ${originScale}`;
          // console.log(newVal);
          // svgNode.setAttribute("transform", newVal);
          this.runToPosition(newWidth, newHeight);
        }
      } else {
        console.log("x,y 属性不符合数字类型");
      }
    },
    runToPosition(x, y) {
      // create zoom handler
      const zoom = d3
        .zoom()
        .scaleExtent([0.1, 10])
        .on("zoom", function() {
          g.attr("transform", d3.event.transform);
        });

      // create a svg
      const svg = d3.select("svg").call(zoom);

      // create svg group that holds all nodes
      const g = d3.select(svg._groups[0][0].children[0]);

      // set zoom identity
      svg.call(zoom.transform, d3.zoomIdentity.translate(x, y).scale(1));
    },
    initTreeWithD3(treeData) {
      let _this = this;
      dTree.init(treeData, {
        target: "#tree",
        debug: true,
        hideMarriageNodes: true,
        marriageNodeSize: 5,
        height: _this.svgStyle.height,
        width: _this.svgStyle.width,
        callbacks: {
          nodeClick: function(name, userId) {
            // alert('左击: ' + name);
          },
          // nodeRightClick: function(name, extra) {
          // 	alert('右击: ' + name);
          // },
          textRenderer: function(name, userId, extra, textClass) {
            if (extra && extra.nickname)
              name = name + " (" + extra.nickname + ")";
            return (
              "<p align='center' class='" + textClass + "'>" + name + "</p>"
            );
          },
          marriageClick: function(extra, id) {
            alert("Clicked marriage node" + id);
          },
          marriageRightClick: function(extra, id) {
            alert("Right-clicked marriage node" + id);
          },
        },
      });
    },
    exportPNG() {
      let _this = this;
      _this.$message({
        message: "正在导出……",
        duration: 1500,
        offset: 230,
        type: "success",
      });
      var serializer = new XMLSerializer();
      var source =
        '<?xml version="1.0" standalone="no"?>\r\n' +
        serializer.serializeToString(d3.select("svg").node());
      var image = new Image();
      image.src =
        "data:image/svg+xml;charset=utf-8," + encodeURIComponent(source);
      var canvas = document.createElement("canvas");

      var svgDom = $(document.querySelector("svg"));
      // var testValue = {
      //   height: svgDom[0].height.animVal.value,
      //   width: svgDom[0].width.animVal.value,
      // };
      // console.log(svgDom);
      // console.log(testValue);
      // console.log(svgDom[0].lastChild.attributes[0].value);

      canvas.width = svgDom[0].width.animVal.value * 4;
      canvas.height = svgDom[0].height.animVal.value * 4;

      var context = canvas.getContext("2d");
      context.fillStyle = "#fff";
      context.fillRect(0, 0, 10000, 10000);
      context.drawImage(image, 0, 0);
      image.onload = function() {
        context.drawImage(image, 0, 0);
        var a = document.createElement("a");
        a.download = _this.exportName;
        a.href = canvas.toDataURL("image/png");
        a.click();
      };
    },
  },
};
</script>
<style>
.container {
  background-color: #fff;
}

.tree-wrapper {
  /* padding-bottom: 80px; */
  min-height: 60px;
  background-color: #fff;
}

.tree-wrapper.print-ready {
  padding-bottom: 0;
}

.tree-container {
  position: relative;
  min-width: 514px;
  height: auto;
  margin: 0 auto;
  overflow: auto;
  text-align: center;
  background-color: #fff;
}

#canvasForTree {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}

.tree-container .child_box {
  width: inherit;
  position: relative;
  height: 32px;
  padding: 30px 0;
  margin: 0 auto;
  white-space: nowrap;
  z-index: 3;
}

.tree-container div a {
  display: inline-block;
  width: 80px;
  height: 30px;
  margin: 0 10px;
  font-size: 14px;
  border: 1px solid #000000;
  border-radius: 5px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 30px;
  color: #333333;
}

.tree-container div a.is_me {
  color: #fb6161;
}

.linage {
  fill: none;
  stroke: #000;
}

.marriage {
  fill: none;
  stroke: black;
}

.marriageNode {
  background-color: black;
  border-radius: 50%;
}

.man {
  line-height: 20px;
  background-color: #fff;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  border-radius: 4px;
}

.woman {
  line-height: 20px;
  background-color: #fff;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  border-radius: 4px;
}

svg.tree-svg {
  border-style: solid;
  border-width: 1px;
  border-color: #cccccc;
  border: none;
}

.is-me {
  color: #fb6161;
  border-color: #000;
}

.export-caontainer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  text-align: center;
  /* z-index: 9999; */
  background-color: #ffffff;
  /* box-shadow: 0 0px 3px rgba(0, 0, 0, 0.3); */
}

.export-btn-wrap {
  padding: 5px 0 5px;
}

.tip-text {
  line-height: 30px;
  color: #606266;
}
</style>
